module.exports = __webpack_public_path__ + "img/program-rules-img.52767951.png";